/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class l{constructor(l=null,a=null,t=null){this.minValue=l,this.maxValue=a,this.noDataValue=t}}export{l as SimpleBandStatistics};
